import Client from 'pages/views/devices/socketClient';
import { setHubEnabled, setHubConnectedOnce } from 'pages/views/devices/utils/storage';

export const handleConnect = () => {
  setHubEnabled();
  setHubConnectedOnce();
  Client.connect();
};
